"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PermissionsClient = void 0;
const fetch_1 = require("../../utils/fetch");
const url_1 = require("../../utils/url");
class PermissionsClient {
    constructor(apiOptions) {
        this.apiOptions = apiOptions;
    }
    async createPermission(request) {
        const path = (0, url_1.buildPathAndQuery)('/permissions', {
            path: {},
            query: {},
        });
        const response = await (0, fetch_1.userActionFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions,
        });
        return response.json();
    }
    async updatePermission(request) {
        const path = (0, url_1.buildPathAndQuery)('/permissions/:permissionId', {
            path: { permissionId: request.permissionId },
            query: {},
        });
        const response = await (0, fetch_1.userActionFetch)(path, {
            method: 'PUT',
            body: request.body,
            apiOptions: this.apiOptions,
        });
        return response.json();
    }
    async archivePermission(request) {
        const path = (0, url_1.buildPathAndQuery)('/permissions/:permissionId/archive', {
            path: { permissionId: request.permissionId },
            query: {},
        });
        const response = await (0, fetch_1.userActionFetch)(path, {
            method: 'PUT',
            body: request.body,
            apiOptions: this.apiOptions,
        });
        return response.json();
    }
    async getPermissionById(request) {
        const path = (0, url_1.buildPathAndQuery)('/permissions/:permissionId', {
            path: { permissionId: request.permissionId },
            query: {},
        });
        const response = await (0, fetch_1.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions,
        });
        return response.json();
    }
    async listPermissions() {
        const path = (0, url_1.buildPathAndQuery)('/permissions', {
            path: {},
            query: {},
        });
        const response = await (0, fetch_1.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions,
        });
        return response.json();
    }
    async createPermissionPredicate(request) {
        const path = (0, url_1.buildPathAndQuery)('/dev-permissions/:permissionId/predicates', {
            path: { permissionId: request.permissionId },
            query: {},
        });
        const response = await (0, fetch_1.userActionFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions,
        });
        return response.json();
    }
    async updatePermissionPredicate(request) {
        const path = (0, url_1.buildPathAndQuery)('/dev-permissions/:permissionId/predicates/:predicateId', {
            path: {
                permissionId: request.permissionId,
                predicateId: request.predicateId,
            },
            query: {},
        });
        const response = await (0, fetch_1.userActionFetch)(path, {
            method: 'PUT',
            body: request.body,
            apiOptions: this.apiOptions,
        });
        return response.json();
    }
    async archivePermissionPredicate(request) {
        const path = (0, url_1.buildPathAndQuery)('/dev-permissions/:permissionId/predicates/:predicateId/archive', {
            path: {
                permissionId: request.permissionId,
                predicateId: request.predicateId,
            },
            query: {},
        });
        const response = await (0, fetch_1.userActionFetch)(path, {
            method: 'PUT',
            body: request.body,
            apiOptions: this.apiOptions,
        });
        return response.json();
    }
    async listPermissionPredicates(request) {
        const path = (0, url_1.buildPathAndQuery)('/dev-permissions/:permissionId/predicates', {
            path: { permissionId: request.permissionId },
            query: {},
        });
        const response = await (0, fetch_1.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions,
        });
        return response.json();
    }
    async createPermissionAssignment(request) {
        const path = (0, url_1.buildPathAndQuery)('/permissions/assignments', {
            path: {},
            query: {},
        });
        const response = await (0, fetch_1.userActionFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions,
        });
        return response.json();
    }
    async revokePermissionAssignment(request) {
        const path = (0, url_1.buildPathAndQuery)('/permissions/assignments/:assignmentId', {
            path: { assignmentId: request.assignmentId },
            query: {},
        });
        const response = await (0, fetch_1.userActionFetch)(path, {
            method: 'DELETE',
            apiOptions: this.apiOptions,
        });
        return response.json();
    }
    async listPermissionAssignments(request) {
        const path = (0, url_1.buildPathAndQuery)('/permissions/assignments', {
            path: {},
            query: request.query ?? {},
        });
        const response = await (0, fetch_1.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions,
        });
        return response.json();
    }
}
exports.PermissionsClient = PermissionsClient;
